import { Link } from 'react-router-dom'
import { Button } from '@winnin/winnin_ui.components.button'

import { ReactComponent as TopicOverview } from 'assets/images/svg/dashboardComponents/topic.svg'
import { useTranslate } from 'lib/tolgee'
import { getRoute } from 'utils/routes'
import { PATHNAMES } from 'utils/routes/consts'

import { translations } from './dashboard-list-empty-state.i18n'
import type { IDashboardListEmptyState } from './dashboard-list-empty-state.types'
import './dashboard-list-empty-state.styles.scss'

export const DashboardListEmptyState = ({ isViewer }: IDashboardListEmptyState) => {
  const t = useTranslate()

  return (
    <div className="DashboardListEmptyState">
      <TopicOverview height="224px" width="241px" />
      <div className="textContent">
        <p>{t(translations.noDashboardsSaved)}</p>
        <span>{t(translations.organizeDashboards)}</span>
        {!isViewer && (
          <Link to={getRoute(PATHNAMES.DASHBOARDS)}>
            <Button appearance="outline">{t(translations.addDashboards)}</Button>
          </Link>
        )}
      </div>
    </div>
  )
}
